/**
 * Metin değerli KPI kartı — kütüphaneye projeden eklenen grafik tipi.
 *
 * Kütüphanenin `kpi` kartı değeri `aggregate()` ile SAYIYA indirger; sayıya
 * çevrilemeyen bir değer (ör. "Renk Değişimi Yok" ya da "11.09.2026 08:11:27")
 * 0 olarak basılır. Panoda iki ölçüt metin döndüğü için, aynı görünümü veren
 * ama değeri olduğu gibi yazan bir tip kaydediliyor (README'deki
 * `registerChart` kaçış kapısı). Kütüphanede düzeltilirse buradaki tip
 * kaldırılıp `kpi`'ya dönülebilir.
 */
import {
  registerChart,
  titleTextStyle,
  useChartTheme,
  valueTextStyle,
} from "@smartopt/charts";

export const TEXT_KPI = "text-kpi";

function TextKpi({ config, data }) {
  const theme = useChartTheme();
  const o = config.options ?? {};
  const measure = config.measures?.[0];
  const key = typeof measure === "string" ? measure : measure?.key;

  /**
   * Başlık `config.title` değil `options.kpiTitle` üzerinden geliyor.
   * ChartRenderer başlığı yalnız `kpi` tipinde atlıyor; burada `config.title`
   * verilseydi kart hem kütüphanenin düz başlığını hem aşağıdaki altın şeridi
   * çizerdi — aynı yazı iki kez görünüyordu.
   */
  const baslik = o.kpiTitle;

  // Kütüphanedeki `kpi` ile aynı seçim: son satırın değeri. Özet kaynakları
  // tek satır döndüğü için bu her zaman o satırdır.
  const son = data?.length ? data[data.length - 1] : null;
  const value = son?.[key];
  const bar = o.titleBar ?? true;

  return (
    <div
      className="soc-kpi"
      style={{ display: "flex", flexDirection: "column", height: "100%" }}
    >
      {baslik && bar && (
        <div
          className="soc-kpi-title"
          style={{
            background: theme.accent,
            ...titleTextStyle(theme, o, {
              size: 12,
              weight: 700,
              color: theme.accentText,
            }),
            letterSpacing: 0.3,
            textAlign: "center",
            lineHeight: 1.15,
            boxSizing: "border-box",
          }}
        >
          {baslik}
        </div>
      )}
      <div
        className="soc-kpi-body"
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div
          className="soc-kpi-value"
          style={{
            ...valueTextStyle(theme, o),
            lineHeight: 1.15,
            textAlign: "center",
          }}
        >
          {value == null || value === "" ? "—" : String(value)}
        </div>
      </div>
    </div>
  );
}

registerChart(TEXT_KPI, TextKpi);
